import type { App } from 'vue'
import axios from 'axios'

const axiosInstance = axios.create({
  // baseURL: baseURL,
  baseURL: import.meta.env.VITE_ADMIN_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Optional: Interceptors hinzufügen
axiosInstance.interceptors.request.use(
  (config) => {
    // Token hinzufügen oder andere Anpassungen vornehmen
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Fehlerbehandlung
    if (error.response && error.response.status === 401) {
      // Zum Beispiel bei 401 (Unauthorized) ausloggen
      // store.dispatch('logout');
    }
    return Promise.reject(error)
  }
)

export const axiosPlugin = {
  install(app: App) {
    app.config.globalProperties.$axios = axiosInstance
    app.provide('axios', axiosInstance)
  }
}

export default axiosInstance
